import { IndexedDbStore } from "@treefort/lib/store/indexed-db"

// There is no such thing as a secure store on the web, just use indexed db
const store = new IndexedDbStore({ key: "auth" })

export default store
